// Major metropolises across every continent, so the globe reads as dense
// worldwide coverage from every rotation angle. Shared by the homepage hero
// globe and the Newswire Distribution reach globe so both render identical
// marker treatment (colour, size, density).
export const REGION_MARKERS = [
  // North America
  { location: [40.71, -74.01], size: 0.13 }, // New York
  { location: [34.05, -118.24], size: 0.11 }, // Los Angeles
  { location: [41.88, -87.63], size: 0.10 }, // Chicago
  { location: [37.77, -122.42], size: 0.09 }, // San Francisco
  { location: [43.65, -79.38], size: 0.10 }, // Toronto
  { location: [49.28, -123.12], size: 0.09 }, // Vancouver
  { location: [19.43, -99.13], size: 0.11 }, // Mexico City
  { location: [25.76, -80.19], size: 0.09 }, // Miami
  { location: [38.91, -77.04], size: 0.09 }, // Washington DC
  // Latin America
  { location: [-23.55, -46.63], size: 0.12 }, // Sao Paulo
  { location: [-22.91, -43.17], size: 0.09 }, // Rio de Janeiro
  { location: [-34.60, -58.38], size: 0.10 }, // Buenos Aires
  { location: [4.71, -74.07], size: 0.09 }, // Bogota
  { location: [-33.45, -70.67], size: 0.08 }, // Santiago
  { location: [-12.05, -77.04], size: 0.08 }, // Lima
  { location: [10.49, -66.88], size: 0.08 }, // Caracas
  // Europe
  { location: [51.51, -0.13], size: 0.13 }, // London
  { location: [48.85, 2.35], size: 0.11 }, // Paris
  { location: [50.11, 8.68], size: 0.10 }, // Frankfurt
  { location: [52.52, 13.40], size: 0.09 }, // Berlin
  { location: [40.42, -3.70], size: 0.10 }, // Madrid
  { location: [45.46, 9.19], size: 0.09 }, // Milan
  { location: [41.90, 12.50], size: 0.09 }, // Rome
  { location: [52.37, 4.90], size: 0.09 }, // Amsterdam
  { location: [47.37, 8.55], size: 0.08 }, // Zurich
  { location: [59.33, 18.07], size: 0.08 }, // Stockholm
  { location: [52.23, 21.01], size: 0.08 }, // Warsaw
  { location: [53.35, -6.26], size: 0.08 }, // Dublin
  // Middle East
  { location: [25.20, 55.27], size: 0.12 }, // Dubai
  { location: [24.45, 54.38], size: 0.09 }, // Abu Dhabi
  { location: [24.71, 46.68], size: 0.10 }, // Riyadh
  { location: [25.29, 51.17], size: 0.08 }, // Doha
  { location: [29.37, 47.98], size: 0.08 }, // Kuwait City
  { location: [30.04, 31.24], size: 0.10 }, // Cairo
  { location: [32.09, 34.78], size: 0.09 }, // Tel Aviv
  { location: [41.01, 28.98], size: 0.10 }, // Istanbul
  // Africa
  { location: [6.52, 3.38], size: 0.11 }, // Lagos
  { location: [-26.20, 28.05], size: 0.10 }, // Johannesburg
  { location: [-33.92, 18.42], size: 0.09 }, // Cape Town
  { location: [-1.29, 36.82], size: 0.08 }, // Nairobi
  { location: [5.60, -0.19], size: 0.08 }, // Accra
  { location: [33.57, -7.59], size: 0.09 }, // Casablanca
  { location: [9.03, 38.74], size: 0.08 }, // Addis Ababa
  // South Asia
  { location: [19.08, 72.88], size: 0.11 }, // Mumbai
  { location: [28.61, 77.21], size: 0.11 }, // New Delhi
  { location: [12.97, 77.59], size: 0.08 }, // Bangalore
  { location: [24.86, 67.01], size: 0.09 }, // Karachi
  { location: [23.81, 90.41], size: 0.09 }, // Dhaka
  { location: [6.93, 79.86], size: 0.08 }, // Colombo
  // East Asia
  { location: [35.68, 139.69], size: 0.12 }, // Tokyo
  { location: [34.69, 135.50], size: 0.09 }, // Osaka
  { location: [37.57, 126.98], size: 0.10 }, // Seoul
  { location: [31.23, 121.47], size: 0.11 }, // Shanghai
  { location: [39.90, 116.41], size: 0.10 }, // Beijing
  { location: [22.32, 114.17], size: 0.11 }, // Hong Kong
  { location: [25.03, 121.57], size: 0.08 }, // Taipei
  // Southeast Asia
  { location: [1.35, 103.82], size: 0.12 }, // Singapore
  { location: [13.76, 100.50], size: 0.09 }, // Bangkok
  { location: [-6.21, 106.85], size: 0.10 }, // Jakarta
  { location: [3.14, 101.69], size: 0.08 }, // Kuala Lumpur
  { location: [14.60, 120.98], size: 0.09 }, // Manila
  { location: [10.82, 106.63], size: 0.09 }, // Ho Chi Minh City
  // Oceania
  { location: [-33.87, 151.21], size: 0.10 }, // Sydney
  { location: [-37.81, 144.96], size: 0.09 }, // Melbourne
  { location: [-36.85, 174.76], size: 0.08 }, // Auckland
];